export enum TipoActividadPrincipal
{
    Dependiente = "Dependiente",
    Independiente = "Independiente",
    Estudiante = "Estudiante",
    DuenaDeCasa = "Dueña de Casa",
    Jubilado = "Jubilado",
    Desempleado = "Desempleado",
    FuerzasArmadas = "Fuerzas Armadas",
    Rentista = "Rentista",
    SocioDeEmpresa = "Socio de Empresa",
    Otros = "Otros",
}